import React from 'react';
import m from 'moment';
import {observer} from 'mobx-react';
import styles from './SinglePersonView.css';
import classnames from 'classnames';

import DayGraphView from './DayGraphView';

function SinglePersonView({person, store}) {
  const eventsByDay = person.eventsByDay;

  const renderView = () => {
    const faulty = eventsByDay.some(day => day.faulty);
    const title = `${person.fullName}
          - ${store.convertToHours(person.totalWorkTime)}
          (${m(store.startDate).format('DD.MM')}
          - ${m(store.endDate).format('DD.MM')})`;

    const handleClick = () => {
      console.log('click');
      person.toggleOpen();
    };

    return (
      <div className={styles.wrapper}>
        <p
          className={classnames({
            [styles.faulty]: faulty,
            [styles.title]: true
          })}
          onClick={handleClick}
        >
          {title}
        </p>
        {person.isOpen ? eventsByDay.map(day => {
          return (
            <DayGraphView
              key={day.time}
              day={day}
              person={person}
              store={store}
            />
          );
        }) : ''}
      </div>
    )
  };

  return renderView()
}

export default observer(SinglePersonView);


// WEBPACK FOOTER //
// ./src/views/Beeper/Components/SinglePersonView.js